import {Command} from './Command';
import {ChangeStairsTransformationAction} from '../actions';
import {RailingGenerationService} from '../../railing/services/railing-generation.service';
import {StageService} from '../../stage.service';

export class ChangeStairsTransformationCommand extends Command<ChangeStairsTransformationAction> {

  action: ChangeStairsTransformationAction;

  constructor(
    private railingGeneration: RailingGenerationService,
    private stageSrvc: StageService
  ) {
    super();
  }

  do(action: ChangeStairsTransformationAction): void {
    this.action = action;
  }

  undo(): void {
    const {config, childrenTransformations} = this.action;
    const stairs = this.stageSrvc.findObject(
      obj => obj.userData.config && obj.userData.config.superstructureId === config.firstPoint.superstructureId
    );
    const cnf = stairs.userData.config;

    cnf.distance = config.distance;
    cnf.width = config.width;
    cnf.firstPoint.distance = config.firstPoint.distance;
    cnf.firstPoint.width = config.firstPoint.width;
    cnf.firstPoint.x = config.firstPoint.x;
    cnf.firstPoint.y = config.firstPoint.y;
    cnf.secondPoint.x = config.secondPoint.x;
    cnf.secondPoint.y = config.secondPoint.y;

    stairs.children.forEach((child, index) => {
      const transform = childrenTransformations[index];
      if (transform) {
        child.position.copy(transform.position);
        child.scale.copy(transform.scale);
      }
    });
    this.railingGeneration.buildRailing(this.railingGeneration.IsVisible());
  }

  dispose() {
    this.action = null;
  }

}



// WEBPACK FOOTER //
// ./src/app/services/eventLog/commands/ChangeStairsTransformationCommand.ts